module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_instant_messaging-285de0c6237d56f13ab65f0ab74eecb9.svg";